import { useContext } from 'react';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import i18n from '~/i18n';
import './style.css';
import { Col, Row } from 'antd';
import SelectTable from './SelectTable';
import SelectOrderType from './SelectOrderType';
import InputCustomerName from './InputCustomerName';
import { MenuOutlined } from '@ant-design/icons';
import { useOpenSidebar } from '../Sidebar';
import InputDelivery from './InputDelivery';

const OrderInfo = () => {
  const { order } = useContext(OrderContext);
  const openSidebar = useOpenSidebar();

  return (
    <div className="order-info-container">
      <div className="first-row">
        <p className="text-xl">
          {!order.isNew
            ? i18n.t('order_info_order_number', { n: order.orderNumber })
            : i18n.t('order_info_new')}
        </p>
        <MenuOutlined onClick={openSidebar} />
      </div>
      <Row gutter={8}>
        <Col span={8}>
          <SelectOrderType />
        </Col>
        <Col span={8}>
          <SelectTable />
        </Col>
        <Col span={8}>
          <InputCustomerName />
        </Col>
      </Row>
      <InputDelivery />
    </div>
  );
};

export default OrderInfo;
